import { render } from "./Pagination-V2.vue?vue&type=template&id=2853a546&ts=true"
import script from "./Pagination-V2.vue?vue&type=script&lang=ts"
export * from "./Pagination-V2.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__